import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import { Options } from "../utils/decorators";

const Weglot = (<any>window).Weglot;

const LANG_CLASS = 'language-switcher__lang';
const LANG_ACTIVE_CLASS = 'language-switcher__lang--active';

@Options({
    template: false,
})
export default class SimpleLanguageSwitcher extends Marionette.View<Backbone.Model>{
    constructor(options?:object) {
        super(options);

        //Run other methods only after initialized
        const interval = setInterval(()=> {
            if (!Weglot.initialized) {
                return;
            }
            clearInterval(interval);
            this.createSwitcher();
        }, 100);
    }

    createSwitcher() {
        // Element to add custom switcher to.
        let languageSwitcher = this.$el.get(0);

        // Create array of options to be added
        let availableLanguages = Weglot.options.languages;

        languageSwitcher.appendChild(
            this.createLink(Weglot.options.language_from, Weglot.options.host)
        );

        //Create and append the options
        for (let i = 0; i < availableLanguages.length; i++) {
            let lang = availableLanguages[i];

            if (!lang.enabled) {
                continue;
            }

            let langHost = null;

            if (lang.connect_host_destination && 'host' in lang.connect_host_destination) {
                langHost = lang.connect_host_destination.host;
            }

            if (!langHost) {
                continue;
            }

            languageSwitcher.appendChild(
                this.createLink(lang.language_to, langHost)
            );
        }
    }

    createLink(langTo, langHost) {
        const option:any = document.createElement("a");
        option.name = langTo;
        option.text = Weglot.getLanguageName(langTo);

        const classes = [LANG_CLASS];

        if (langTo === Weglot.getCurrentLang()) {
            classes.push(LANG_ACTIVE_CLASS);
        }

        option.setAttribute('class', classes.join(' '));

        //Switch language on click
        option.onclick = function() {
            window.location.host = langHost;
        }

        return option;
    }
}



// WEBPACK FOOTER //
// ./@modules/views/simple-language-switcher.ts